import * as React from 'react';

import { Divider } from '../divider/divider.component';
import { achievementsData, AchievementTypes } from './data';
import {
  Achievements,
  ExperiencePointsDetailed,
  GeneralProgress,
  Header,
  KnowMoreAction,
  LevelsAchieved,
  Progress,
  Streaks,
} from './sub-components';
export interface StatisticsProps {
  onCloseClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  title: string;
  data: typeof achievementsData;
}

const dividerStyle = { marginBottom: 48, marginTop: 48 };

const { Fragment } = React;

export const Statistics = ({ onCloseClick, title, data }: StatisticsProps): JSX.Element => {
  return (
    <div className="px-24">
      <Header title={title} onCloseClick={onCloseClick} className="py-16 mb-24" />
      {data.map((single, index) => (
        <Fragment key={`${single.type}-${index}`}>
          {single.type === AchievementTypes.PROGRESS ? (
            <Progress title={single.title} key={single.title}>
              <GeneralProgress
                currentPoints={single.progress?.currentPoints}
                targetLevel={single.progress?.targetLevel}
                targetPoints={single.progress?.targetPoints}
              />
              <LevelsAchieved
                levels={single.levelAchieved?.levels}
                title={single?.levelAchieved?.title}
                className="mt-30"
              />
            </Progress>
          ) : single.type === AchievementTypes.STREAKS ? (
            <Streaks
              title={single.title}
              streakDay={single.streakDay}
              description={single.description}
              streaks={single.streaksItem}
              key={single.title}
            />
          ) : single.type === AchievementTypes.ACHIEVEMENTS ? (
            <Achievements
              description={single.description}
              title={single.title}
              latestAchievements={single.latestAchievements}
              key={single.title}
            />
          ) : single.type === AchievementTypes.EXPERIENCE_POINTS_DETAILED ? (
            <ExperiencePointsDetailed
              title={single.title}
              listItems={single.actionPoints}
              image={single.image}
              key={single.title}
            />
          ) : single.type === AchievementTypes.KNOW_MORE_ACTION ? (
            <KnowMoreAction
              className="mb-24"
              actionBtnTxt={single.actionBtnTxt}
              description={single.description}
              title={single.title}
              key={single.title}
            />
          ) : null}
          {data.length - 1 === index ? null : <Divider style={dividerStyle} />}
        </Fragment>
      ))}
    </div>
  );
};
